import { useState } from 'react';
import styled from 'styled-components';
import Modal from 'components/ui-components/Modal';
import Button from 'components/ui-components/Button';
import { CloseXmark } from 'assets/icons';

const RegistrationModal = ({ isOpen, text, buttonStyle }) => {
  const [modalOpen, setModalOpen] = useState(isOpen);

  return (
    <>
      <button
        type="button"
        className={buttonStyle}
        onClick={() => setModalOpen(true)}>
        {text}
      </button>
      <div className="registration-modal">
        <RegModal isOpen={modalOpen} closeModal={() => setModalOpen(false)}>
          <div className="fl fl-col margin-center registration-modal__container">
            <CloseButton
              label="close modal"
              handleClick={() => setModalOpen(false)}>
              <CloseXmark />
            </CloseButton>
            <div className="fl fl-col m-fl-row jc-sb g-16">
              <a
                href="/mycef/account/new?account=true"
                className="p-24 b-none bg-cef-red modal-box">
                <div className="fl fl-col l-jc-fs height-100 p-16">
                  <h2 className="fw-900 ff-body tc-white ta-l m-0 p-0 mb-20 bg-none fs-28 lh-2-rem">
                    Already have a CEF account
                  </h2>
                  <p className="ff-body tc-white ta-l lf">
                    Activate your account to enable online ordering and keep up
                    to date with the latest offers.
                  </p>
                </div>
              </a>
              <a
                href="/mycef/account/new"
                className="p-24 b-none bg-cef-red modal-box">
                <div className="fl fl-col l-jc-fs height-100 p-16">
                  <h2 className="fw-900 ff-body tc-white ta-l m-0 p-0 mb-20 bg-none fs-28 lh-2-rem">
                    Need to create a CEF account
                  </h2>
                  <p className="ff-body tc-white ta-l lf">
                    Create your new CEF trade account in minutes and start
                    ordering right away.
                  </p>
                </div>
              </a>
            </div>
          </div>
        </RegModal>
      </div>
    </>
  );
};

const CloseButton = styled(Button)`
  align-self: flex-end;
  background-color: inherit;
  transform: translateX(24px);
  margin: 8px;
  @media only screen and (min-width: 768px) {
    margin: 8px;
    transform: translateX(40px);
  }
`;

const RegModal = styled(Modal)`
  > div {
    padding: 0 2rem 6rem 2rem;
    width: 326px;
    height: 500px;
    @media only screen and (min-width: 768px) {
      padding: 0px 3rem 3rem 3rem;
      width: 604px;
      height: 292px;
    }
  }
`;

export default RegistrationModal;
